import type { operations } from '@/api'
import { put } from './client'

export type UpdateProjectPath = `/api/workspaces/${string}/projects/${string}`
export type UpdateProjectResponse =
  operations['project-update']['responses']['200']['content']['application/json']

export type UpdateProjectRequest = Exclude<
  operations['project-update']['requestBody'],
  undefined
>['content']['application/json']

export const updateProject = (
  workspaceId: string,
  projectId: string,
  payload: {
    name: UpdateProjectRequest['name']
    description?: UpdateProjectRequest['description']
    auto_recalculations?: UpdateProjectRequest['auto_recalculations'] | null
  },
) =>
  put<UpdateProjectRequest, UpdateProjectResponse, UpdateProjectPath>(
    `/api/workspaces/${workspaceId}/projects/${projectId}`,
    {
      name: payload.name,
      description: payload.description,
      /**
       * There is a bug in openapi-typescript where an OpenAPI spec's optional nullable boolean
       * is typed as a required boolean (i.e. null/undefined are allowed in the API spec
       * bet are incorrectly excluded from the autogenerated TS definitions).
       *
       * This is a workaround to satisfy the type checker. We don't want to pass a boolean
       * here because we don't want to override the value.
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      auto_recalculations: payload.auto_recalculations as any,
    },
  )
